import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
import { HotelRecentReviewsFlexModuleResult } from "typings/microserviceModels/hotel-recent-reviews-flex-module";

const HeaderImageCardModuleTitle = (props: { model: HotelRecentReviewsFlexModuleResult }) => {
  const { title, showSubtitleForHeaderImageView, brandName } = props.model;
  const { formatText } = useLocalization();

  return (
    <>
      <UitkHeading level={2} size={600}>
        {title}
      </UitkHeading>

      {showSubtitleForHeaderImageView && (
        <UitkSubheading level={3}>{formatText("hotelRecentReviews.brandVerifiedReviews", brandName)}</UitkSubheading>
      )}
    </>
  );
};

export default HeaderImageCardModuleTitle;
